/* RAVIN / FIT LAB / Session-only measurement memory.
   Values are stored in sessionStorage for this storefront tab, never permanent
   storage, cookies, Shopify customer records, or analytics. */
(()=>{
 if(window.__RavinFitLabSession2026)return;
 window.__RavinFitLabSession2026=true;
 const KEY='ravin.fitlab.measurements.session.v1';
 const LIMITS={chestBustCm:[40,220],waistCm:[30,220],hipsCm:[40,220],
   heightCm:[100,250],weightKg:[25,250]};
 const keys=Object.keys(LIMITS);
 const valid=(key,value)=>{
   const str=String(value??'').trim();
   const n=Number(str),bounds=LIMITS[key];
   return str.length>0&&str.length<=12&&Number.isFinite(n)&&n>=bounds[0]&&n<=bounds[1];
 };
 function read(){
   try{
     const data=JSON.parse(sessionStorage.getItem(KEY)||'null');
     if(!data||data.version!==1||!data.values||typeof data.values!=='object')return {};
     const values={};
     keys.forEach(key=>{if(valid(key,data.values[key]))values[key]=String(data.values[key]).trim()});
     return values;
   }catch(e){return {}}
 }
 function save(values){
   try{
     if(!Object.keys(values).length)sessionStorage.removeItem(KEY);
     else sessionStorage.setItem(KEY,JSON.stringify({version:1,values}));
   }catch(e){/* Private browsing or storage denied: the form continues normally. */}
 }
 function active(){
   return document.querySelector('.rv-fl-overlay[data-open="true"][data-rv-fl-view="fit"][data-rv-fl-chapter="1"]');
 }
 function remember(form){
   if(!form)return;
   const values={};
   keys.forEach(key=>{
     const input=form.querySelector('[data-field="'+key+'"]');
     if(input&&valid(key,input.value))values[key]=input.value.trim();
   });
   save(values);
 }
 function refreshCTA(overlay){
   const form=overlay?.querySelector('[data-rv-fl-measure-form]');
   if(!form)return;
   const ready=['chestBustCm','waistCm','hipsCm'].every(key=>{
     const input=form.querySelector('[data-field="'+key+'"]');
     return input&&input.value.trim()&&input.checkValidity();
   });
   for(const button of [overlay.querySelector('[data-rv-fl-mobile-continue]'),form.querySelector('.rv-fl-guided-inline-continue')]){
     if(!button)continue;
     button.disabled=!ready;
     button.setAttribute('aria-disabled',String(!ready));
   }
 }
 function attach(overlay){
   if(!overlay)return;
   const form=overlay.querySelector('[data-rv-fl-measure-form]');
   if(!form)return;
   if(form.dataset.rvFlSessionReady==='yes')return;
   form.dataset.rvFlSessionReady='yes';
   const saved=read();
   keys.forEach(key=>{
     const input=form.querySelector('[data-field="'+key+'"]');
     if(input&&saved[key]&&!input.value.trim())input.value=saved[key];
   });
   const optional=form.querySelector('[data-rv-fl-optional]');
   if(optional&&(saved.heightCm||saved.weightKg))optional.open=true;
   const note=document.createElement('div');
   note.className='rv-fl-session-tools';
   const caption=document.createElement('span');
   caption.textContent=overlay.dir==='rtl'?'مقاساتك محفوظة خلال جلسة التصفح دي بس':
     'Measurements remembered for this browsing session';
   const clear=document.createElement('button');
   clear.type='button';
   clear.textContent=overlay.dir==='rtl'?'امسح المقاسات':'CLEAR MEASUREMENTS';
   clear.setAttribute('data-rv-fl-clear-saved','');
   clear.addEventListener('click',()=>{
     save({});
     keys.forEach(key=>{
       const field=form.querySelector('[data-field="'+key+'"]');
       if(field){field.value='';field.dispatchEvent(new Event('input',{bubbles:true}))}
     });
     save({});
     if(optional)optional.open=false;
     refreshCTA(overlay);
     form.querySelector('[data-field="chestBustCm"]')?.focus({preventScroll:true});
   });
   note.append(caption,clear);
   if(optional)optional.insertAdjacentElement('afterend',note);
   else form.append(note);
   refreshCTA(overlay);
 }
 let pending=false;
 function update(){
   pending=false;
   attach(active());
 }
 function schedule(){
   if(pending)return;pending=true;
   queueMicrotask(update);
 }
 function start(){
   if(!document.body)return;
   const observer=new MutationObserver(schedule);
   observer.observe(document.body,{subtree:true,childList:true,attributes:true,
     attributeFilter:['data-open','data-rv-fl-chapter','data-rv-fl-view']});
   document.addEventListener('input',event=>{
     const field=event.target;
     if(!field.matches?.('.rv-fl-overlay [data-field]'))return;
     const overlay=active();
     if(!overlay)return;
     remember(overlay.querySelector('[data-rv-fl-measure-form]'));
     refreshCTA(overlay);
   },true);
   document.addEventListener('change',event=>{
     if(!event.target.matches?.('.rv-fl-overlay [data-field]'))return;
     const overlay=active();
     if(overlay){remember(overlay.querySelector('[data-rv-fl-measure-form]'));refreshCTA(overlay)}
   },true);
   schedule();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
 else start();
})();